module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ag-4852b5c91714f95f37970257ff03eee0.svg";